"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreationModalWrapper = exports.CreationModalContent = void 0;
var _formik = require("formik");
var _react = _interopRequireWildcard(require("react"));
var _alloyReactButton = _interopRequireDefault(require("@adsk/alloy-react-button"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactModal = _interopRequireDefault(require("@adsk/alloy-react-modal"));
var _alloyReactCheckbox = _interopRequireDefault(require("@adsk/alloy-react-checkbox"));
var _EscapePressHandler = require("./EscapePressHandler");
var _DiscardModal = require("./DiscardModal");
var _useModalConfirmationState = require("../hooks/useModalConfirmationState");
var _CenteredSpinner = require("./CenteredSpinner");
var _useTranslations = require("../i18n/useTranslations");
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CreationModalContent = _ref => {
  let {
    onClose,
    onCreate,
    title,
    createAnotherEntityText,
    errors,
    initialValues,
    persistedFieldsAfterReset,
    children,
    createEntity,
    handleValidation,
    validationSchema,
    confirmationModalComponent: ConfirmationModal,
    shouldShowConfirmationModalFn,
    createButtonText,
    onDiscardConfirm,
    onDiscardAbort
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  createButtonText = createButtonText || T.translate("actions.create");
  const {
    show: isConfirmationModalOpen,
    waitForConfirmation,
    onConfirm,
    onClose: onCancel
  } = (0, _useModalConfirmationState.useModalConfirmationState)();
  const containerRef = (0, _react.useRef)(null);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = _react.default.useState(false);
  const [isDiscardModalOpen, setIsDiscardModalOpen] = (0, _react.useState)(false);
  const [shouldCreateAnotherEntity, setShouldCreateAnotherEntity] = (0, _react.useState)(false);
  const handleFormSubmission = (0, _react.useCallback)(async (attributes, _ref2) => {
    let {
      resetForm
    } = _ref2;
    if (ConfirmationModal && shouldShowConfirmationModalFn && shouldShowConfirmationModalFn(attributes)) {
      const isConfirmed = await waitForConfirmation();
      if (!isConfirmed) {
        return;
      }
    }
    try {
      var _await$createEntity;
      const [entity, entitySubResources] = (_await$createEntity = await createEntity(attributes)) !== null && _await$createEntity !== void 0 ? _await$createEntity : [];
      if (!entity) {
        throw new Error("Entity failed to be created");
      }
      setIsSubmitSuccessful(true);
      onCreate === null || onCreate === void 0 || onCreate(entity, entitySubResources);
      if (!shouldCreateAnotherEntity) {
        onClose(true);
      } else {
        const values = initialValues;
        Object.keys(attributes).forEach(key => {
          if (persistedFieldsAfterReset && persistedFieldsAfterReset.includes(key)) {
            values[key] = attributes[key];
          }
        });
        resetForm({
          values
        });
        setIsSubmitSuccessful(false);
      }
    } catch (e) {
      // @TODO: we should probably bugsnag this.
      // We also shouldn't be silently ignoring errors here -- this should maybe trigger a notification.
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }, [shouldCreateAnotherEntity, createEntity, onClose, onCreate, ConfirmationModal, waitForConfirmation, shouldShowConfirmationModalFn, initialValues, persistedFieldsAfterReset]);
  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: initialValues,
    onSubmit: handleFormSubmission,
    validate: handleValidation,
    validationSchema: validationSchema
  }, _ref3 => {
    let {
      handleSubmit,
      isSubmitting,
      dirty,
      values,
      setFieldError,
      errors: formikErrors
    } = _ref3;
    if (errors) {
      Object.entries(errors).forEach(_ref4 => {
        let [errorKey, errorValue] = _ref4;
        if (formikErrors[errorKey] !== errorValue) {
          setFieldError(errorKey, errorValue);
        }
      });
    }
    const onCloseAttempt = () => dirty ? setIsDiscardModalOpen(true) : onClose();

    // hasSubmittedForm allows us to keep showing the loader while the modal fades away.
    // Using formik's `submitCount` doesn't work because that includes
    // attempted submissions that ran into errors.
    const hasSubmittedForm = isSubmitting || isSubmitSuccessful;
    const handleDiscard = () => {
      const dirtyValues = (0, _lodash.pickBy)(values,
      //@ts-ignore
      (value, field) => initialValues[field] !== value);
      onClose(false, dirtyValues);
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: containerRef
    }, /*#__PURE__*/_react.default.createElement(_alloyReactModal.default.Header, null, title, " ", /*#__PURE__*/_react.default.createElement(_alloyReactModal.default.Close, {
      onClick: onCloseAttempt
    })), /*#__PURE__*/_react.default.createElement(_EscapePressHandler.EscapePressHandler, {
      onEscapePress: onCloseAttempt
    }), hasSubmittedForm && /*#__PURE__*/_react.default.createElement(_CenteredSpinner.AbsoluteCenteredSpinner, {
      zIndex: _alloyReactTheme.default.zIndex.overlay
    }), /*#__PURE__*/_react.default.createElement(_alloyReactModal.default.Body, {
      style: {
        maxHeight: "70vh",
        padding: "0px 24px 16px",
        opacity: hasSubmittedForm ? 0 : 1
      }
    }, children, /*#__PURE__*/_react.default.createElement(_DiscardModal.DiscardModal, {
      isOpen: isDiscardModalOpen,
      onDiscard: handleDiscard,
      closeDiscardModal: () => setIsDiscardModalOpen(false),
      onDiscardConfirm: onDiscardConfirm,
      onDiscardAbort: onDiscardAbort
    }), ConfirmationModal && /*#__PURE__*/_react.default.createElement(ConfirmationModal, {
      show: isConfirmationModalOpen,
      onConfirm: onConfirm,
      onClose: onCancel
    })), /*#__PURE__*/_react.default.createElement(_alloyReactModal.default.Footer, {
      style: {
        justifyContent: createAnotherEntityText ? "space-between" : "flex-end"
      }
    }, createAnotherEntityText && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/_react.default.createElement(_alloyReactCheckbox.default, {
      checked: shouldCreateAnotherEntity,
      onChange: value => setShouldCreateAnotherEntity(!!value)
    }), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        paddingLeft: 8
      }
    }, createAnotherEntityText)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_alloyReactButton.default, {
      disabled: hasSubmittedForm,
      variant: _alloyReactButton.default.VARIANTS.TERTIARY,
      onClick: onCloseAttempt
    }, T.translate("actions.cancel")), /*#__PURE__*/_react.default.createElement(_alloyReactButton.default, {
      disabled: hasSubmittedForm,
      variant: _alloyReactButton.default.VARIANTS.PRIMARY,
      style: {
        marginLeft: 16
      },
      onClick: () => handleSubmit()
    }, createButtonText))));
  });
};
exports.CreationModalContent = CreationModalContent;
const CreationModalWrapper = _ref5 => {
  let {
    isOpen,
    children
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(_alloyReactModal.default, {
    open: isOpen,
    size: _alloyReactModal.default.SIZES.MEDIUM,
    height: "inherit",
    shouldCloseOnEsc: false
  }, isOpen && children);
};
exports.CreationModalWrapper = CreationModalWrapper;
//# sourceMappingURL=CreationModal.js.map